export type MasterProfileDirection = string;

export function parseMasterProfileDirections(
  data: unknown,
): MasterProfileDirection[] {
  const source = Array.isArray(data)
    ? data
    : typeof data === 'object' && data !== null && 'directions' in data
      ? (data as { directions?: unknown }).directions
      : [];
  const values = Array.isArray(source) ? source : [source];
  const seen = new Set<MasterProfileDirection>();
  const directions: MasterProfileDirection[] = [];

  values.forEach((value) => {
    if (typeof value !== 'string') return;
    value.split(',').forEach((rawDirection) => {
      const direction = rawDirection.trim();
      if (direction && !seen.has(direction)) {
        seen.add(direction);
        directions.push(direction);
      }
    });
  });

  return directions;
}

export function normalizeMasterProfileDirections(
  directions: readonly string[],
  allowedDirections: readonly string[],
): MasterProfileDirection[] {
  const allowed = new Set(allowedDirections);
  const seen = new Set<MasterProfileDirection>();
  const normalized: MasterProfileDirection[] = [];

  directions.forEach((direction) => {
    if (!allowed.has(direction)) {
      throw new Error(`Недопустимое направление мастера: ${direction}`);
    }
    if (!seen.has(direction)) {
      seen.add(direction);
      normalized.push(direction);
    }
  });

  return normalized;
}

export function filterAvailableMasterProfileDirections(
  directions: readonly string[],
  allowedDirections: readonly string[],
): MasterProfileDirection[] {
  const allowed = new Set(allowedDirections);
  return directions.filter((direction, index) => (
    allowed.has(direction) && directions.indexOf(direction) === index
  ));
}
